<!-- eslint-disable -->
<template lang="pug">
    div
        .form__title
            slot(name='title')
        form.form__body(action='javascript://' v-if='params')
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_view') }}
                .form__field-body
                    cs-multiselect(
                        :multiple='false',
                        :options='viewTypes',
                        :show-labels='false',
                        :allow-empty='false',
                        track-by='name',
                        label='name',
                        :placeholder="$i18n.t('trainer.trainer_gameFormSetting_chooseViewType')",
                        v-model='viewType',
                        @select='params.viewType = $event.type'
                    )
            .form__field(v-if="gameMode !== 'course'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_topics') }}
                .form__field-body
                    cs-multiselect(
                        :options="topics"
                        :max="BREAK_TOPICS_AMOUNT"
                        :show-labels="false"
                        :hide-selected="true"
                        :close-on-select="false"
                        :clear-on-select="false"
                        placeholder=""
                        :multiple="true"
                        v-model="selectedTopics"
                        track-by='mode',
                        label='name',
                        :disabled="topics.length === 0"
                        v-validate="'required'"
                        data-vv-value-path="innerValue"
                        data-vv-name="topics"
                        :data-vv-as="$i18n.t('homework.homework_create_studentsVvSs')"
                    )
                        span(slot="maxElements")
                            | {{ $i18n.t('trainer.trainer_gameFormSettings_maxAmountOfElements') }}
            .form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
                label.form__label
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_tableSize') }}
                .form__field-body
                    cs-multiselect(
                        :options="difficulties"
                        v-model="params.difficult"
                        :placeholder="tableLabel(params.difficult)"
                        :custom-label="tableLabel"
                        :multiple="false"
                        :allow-empty="false"
                    )
            divider
            slot(name='parameters')
            slot(name='help')
            .form__buttons(v-if='!usersIds')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                template(v-if="gameMode === 'free-game'")
                    cs-button.form__button(color="blue", @click='saveGameMode' :disabled="isSaveButtonDisabled")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
                template(v-else='')
                    cs-button.form__button(color="blue", @click='saveGame' :disabled="isSaveButtonDisabled")
                        | {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
            .form__buttons(v-else='')
                cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
                cs-button.form__button(color="blue", @click='saveGame' :disabled="isSaveButtonDisabled")
                    | {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from "../../../utils/trainer/GameFormMixin";
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from "../../../utils/trainer/getInitParameters";
    import { mapState } from 'vuex';
    import _ from "lodash";
    import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";
    import ClassificationGameApi from '../../../api/games/classificationGameApi'
    const BREAK_TOPICS_AMOUNT = 10;

    export default {
        props: {
            slug: String,
            courseType: String,
            id: [Number, String],
            usersIds: [Array, String],
            homeworkId: [Number, String],
            gameMode: String,
            gameId: [Number, String],
            generatorGameIndex: Number,
            generatorSettings: Boolean,
            levelAnswerDuration: Number,
        },
        mixins: [GameFormMixin, multiplayerFormMixin],
        data () {
            return {
                viewTypes: [
                    {
                        name: this.$i18n.t('couples.couples_view_image'),
                        type: 'image'
                    },
                    {
                        name: this.$i18n.t('couples.couples_view_word'),
                        type: 'word'
                    }
                ],
                imageGroups: [],
                wordGroups: [],
                selectedTopics: [],
                params: null,
                viewType: null,
                BREAK_TOPICS_AMOUNT,
            }
        },
        mounted() {
            this.getTopics();
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params', getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: _.cloneDeep(this.gamesParameters[this.slug])
                        }
                    }));
                } else {
                    this.params = _.cloneDeep(TrainerGames.games).find(item => item.slug === this.slug).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
            this.viewType = _.find(this.viewTypes, { type: this.params.viewType });
            this.selectedDifficult = this.params.difficult;
            if (this.params.selectedTopics && this.params.selectedTopics.length) {
                this.selectedTopics = this.params.selectedTopics.map(topic => {
                    return {name: this.$i18n.t('trainer.trainer_gameFormSettingValue_' + topic) , mode: topic};
                });
            }
        },
        updated () {
            this.viewType = _.find(this.viewTypes, { type: this.params.viewType });
            this.selectedDifficult = this.params.difficult;
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user
            }),
            difficulties () {
                let difficulties = [];
                let breakSize = this.params.viewType === 'image' ? 10 : 5;
                for (let i = 2; i <= BREAK_TOPICS_AMOUNT; i++) {
                    for (let j = 2; j <= breakSize; j++) {
                        difficulties.push({amountOfRows: i, amountOfColumns: j});
                    }
                }
                return difficulties.filter(difficult => this.selectedTopics.length === difficult.amountOfRows);
            },
            topics () {
                let groups = [];
                switch (this.params.viewType) {
                    case ('image'):
                        groups = this.imageGroups;
                        break;
                    case ('word'):
                        groups = this.wordGroups;
                        break;
                }
                return groups.map(topic => {
                    return {name: this.$i18n.t('trainer.trainer_gameFormSettingValue_' + topic) , mode: topic}
                }).sort(this.sortTopicsByName)
            },
            isSaveButtonDisabled () {
                return this.selectedTopics.length < 2;
            }
        },
        watch: {
            'selectedTopics': {
                handler (val) {
                    if (val) {
                        if (val.length !== this.params.selectedTopics.length) {
                            this.params.difficult = {amountOfRows: val.length, amountOfColumns: 2};
                        }
                        this.params.selectedTopics = val.map(topic => topic.mode);
                    }
                }
            },
            'params.viewType': {
                handler (newVal, oldVal) {
                    if (newVal && oldVal) {
                        newVal !== oldVal && (this.selectedTopics = []);
                    }
                }
            }
        },
        methods: {
            getTopics () {
                ClassificationGameApi.getGroups(this.user.locale)
                .then(data => ({imageGroups: this.imageGroups, wordGroups: this.wordGroups} = data));
            },
            sortTopicsByName (firstTopic, secondTopic) {
                const firstTopicName = firstTopic.name.toUpperCase();
                const secondTopicName = secondTopic.name.toUpperCase();
                if (firstTopicName < secondTopicName) {
                    return -1;
                } else if (firstTopicName > secondTopicName) {
                    return 1;
                }
                return 0;
            },
            tableLabel (difficult) {
                return difficult.amountOfRows + ' x ' + difficult.amountOfColumns;
            },
        }
    }
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__field--column {
        flex-direction: column;
        margin-bottom: 20px;
        align-items: flex-start;
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            min-width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            width: 13em;
            min-width: 13em;
        }
    }

    .form__label--left {
        min-width: 0;
        width: auto;
        margin-bottom: 20px;
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__field-body--inline {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .numbers-checkbox:not(:last-child) {
        margin-right: 10px;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>

